import { render, staticRenderFns } from "./AddEditAlbum.vue?vue&type=template&id=9ca474d2&scoped=true&"
import script from "./AddEditAlbum.vue?vue&type=script&lang=js&"
export * from "./AddEditAlbum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ca474d2",
  null
  
)

export default component.exports